function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import classnames from 'classnames';
import TextField from 'material-ui/TextField';
import { Notification } from '../notification';
import COLORS from './colors';
import classes from './underlined-input.scss';
const style = {
  underlineStyle: {
    bottom: '6px',
    borderBottom: `1px solid ${COLORS.light.border}`
  },
  wrapperStyle: {
    marginBottom: '-8px'
  },
  floatingLabelStyle: {
    color: COLORS.light.text
  }
};
export default class UnderlinedInput extends React.Component {
  renderUnderlineStyle(showNotification) {
    const {
      meta: {
        error,
        warning
      }
    } = this.props;
    const newStyle = _objectSpread({}, style, {
      underlineStyle: _objectSpread({}, style.underlineStyle)
    });
    if (showNotification && error) {
      newStyle.underlineStyle.borderBottom = `1px solid ${COLORS.error.border}`;
    } else if (showNotification && warning) {
      newStyle.underlineStyle.borderBottom = `1px solid ${COLORS.warning.border}`;
    }
    return _objectSpread({}, newStyle.underlineStyle);
  }
  render() {
    var _input$name, _input$name2;
    const {
      input,
      label,
      type,
      className,
      containerClassName,
      errorClassName,
      dataInput,
      autoComplete,
      floatingLabelFixed,
      meta: {
        touched,
        active,
        error,
        warning
      },
      children,
      autoFocus = false
    } = this.props;
    const showNotification = touched && !active;
    return /*#__PURE__*/React.createElement("div", {
      className: classnames(classes.container, containerClassName)
    }, /*#__PURE__*/React.createElement(TextField, _extends({}, input, {
      autoComplete: autoComplete,
      type: type,
      className: className,
      style: style.wrapperStyle,
      underlineStyle: this.renderUnderlineStyle(showNotification),
      floatingLabelText: label,
      "data-input": dataInput,
      floatingLabelFixed: floatingLabelFixed,
      floatingLabelStyle: style.floatingLabelStyle,
      autoFocus: autoFocus
    })), children, /*#__PURE__*/React.createElement(Notification, {
      errorClassName: errorClassName,
      showNotification: !!showNotification,
      error: error,
      warning: warning,
      dataLabel: `Error${((_input$name = input.name) === null || _input$name === void 0 ? void 0 : _input$name[0].toUpperCase()) + ((_input$name2 = input.name) === null || _input$name2 === void 0 ? void 0 : _input$name2.substr(1))}`
    }));
  }
}